(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbd-content-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pbd-story-carousel')) {
  customElements.define('pbd-story-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.pbd-story__track');
      this.slides = Array.from(this.querySelectorAll('.pbd-story__slide'));
      this.count = this.querySelector('.pbd-story__count');
      this.index = 0;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.step)), opts));
      this.track.addEventListener('scroll', () => {
        const base = this.track.getBoundingClientRect().left;
        let best = 0;
        this.slides.forEach((slide, i) => { if (Math.abs(slide.getBoundingClientRect().left - base) < Math.abs(this.slides[best].getBoundingClientRect().left - base)) best = i; });
        this.index = best;
        this.count.textContent = (best + 1) + ' / ' + this.slides.length;
      }, {...opts, passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, opts);
      this.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (i >= 0) this.go(i, true);
      }, opts);
    }
    go(i, instant = false) {
      if (!this.slides.length) return;
      this.index = (i + this.slides.length) % this.slides.length;
      const target = this.slides[this.index];
      const left = this.track.scrollLeft + target.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({left, behavior:instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbd-newsletter-welcome"]) return;
  try {
    
(() => {
  const panel = document.querySelector('[data-pbd-welcome]');
  if (!panel) return;
  const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const seenKey = 'pbd_welcome_seen_v1';
  const startKey = 'pbd_session_start_v1';
  const start = Number(read(startKey)) || Date.now();
  write(startKey, String(start));
  let opener = null;
  const open = (manual = false) => {
    panel.hidden = false;
    write(seenKey, '1');
    if (manual) panel.querySelector('input[type=email]')?.focus();
  };
  const close = () => { panel.hidden = true; opener?.focus(); opener = null; };
  panel.querySelector('[data-pbd-welcome-close]')?.addEventListener('click', close);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !panel.hidden) close(); });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pbd-welcome-open]');
    if (!button) return;
    opener = button;
    button.closest('dialog')?.close();
    open(true);
  });
  if (panel.querySelector('[data-pbd-welcome-success], [data-pbd-welcome-error]')) { open(); return; }
  if (read(seenKey)) return;
  const reveal = () => {
    if (document.visibilityState === 'hidden' || [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([hidden])')].some((el) => el.getClientRects().length > 0)) { window.setTimeout(reveal, 500); return; }
    open();
  };
  window.setTimeout(reveal, Math.max(0, start + 5000 - Date.now()));
})();

  } catch(e) { console.error(e); }
})();
})();
